// react
import { useEffect } from 'react';

// components
import { CareConciergeReferral as CareConciergeReferralPage } from '@karehero/llama/pwa/pages/CareConciergeReferral/CareConciergeReferral';

// hooks
import { TrackingEvent, useTracking, useAuth } from 'hooks';

export const CareConciergeReferral = () => {
  // hooks
  const { signIn, register } = useAuth();
  const { track } = useTracking();

  // effects
  useEffect(() => {
    track(TrackingEvent.ExternalPartnerReferralFormViewed, {});
  }, [track]);

  return (
    <CareConciergeReferralPage
      onRegister={register}
      onSignIn={signIn}
      videoPlaybackID={
        import.meta.env.REACT_APP_KAREHERO_APP_DEMO_VIDEO_PLAYBACK_ID
      }
      videoThumbnailTime={parseFloat(
        import.meta.env.REACT_APP_KAREHERO_APP_DEMO_VIDEO_THUMBNAIL_TIME ||
          '0.0',
      )}
    />
  );
};

export default CareConciergeReferral;
